import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FatherService } from './father.service';
import { LocalstorageService } from './localstorage.service';
import { Observable } from 'rxjs';
import { LicenseInterface } from '../interfaces/license.interface';

@Injectable({
  providedIn: 'root'
})
export class LicenseService extends FatherService {

  constructor(
    httpClient: HttpClient,
    localstorageService: LocalstorageService
  ) {
    super(httpClient, localstorageService);
  }

  getModule(): Observable<any> {
    return this.get('/api-license/module-list')
  }

  getLicenseList(): Observable<any> {
    return this.get('/api-license/license-data')
  }

  updateLicense(data: LicenseInterface): Observable<any> {
    return this.patch(`/api-license/license-data/${data.id}`, data)
  }

  createModule(data: { module_key: string, description: string; price?: number }): Observable<any> {
    return this.post('/api-license/module-list', data)
  }

  updateModule(id: number, data: { module_key: string; description: string; price?: number }): Observable<any> {
    return this.patch(`/api-license/module-list/${id}`, data);
  }

  deleteModule(id: number): Observable<any> {
    return this.delete(`/api-license/module-list/${id}`);
  }

  registerLicense(data: LicenseInterface) {
    return this.post('/api-license/license-data', data)
  }

}
